import React from "react";
import { Button, Popover, DateBox, SelectBox, TextBox, Validator } from "devextreme-react";
import moment from "moment";

class HoursRanges extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      desde: null,
      hasta: null,
      filtrarValid: true,
      filterValue: {
        text: null,
        value: {
          from: null,
          to: null,
        },
      },
    };
  }

  componentDidMount() {
    this.manageState(this.props);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.useData !== prevProps.useData || this.props.minValue !== prevProps.minValue) {
      this.manageState(this.props);
    }
  }

  manageState = (props) => {
    let filterValue;
    if (props.minValue != null && props.maxValue != null) {
      this.setState({
        open: false,
        desde: props.minValue || null,
        hasta: props.maxValue || null,
        filterValue: {
          text: (props.minValue && props.maxValue) && `${moment(props.minValue).format("HH:mm")} - ${moment(props.maxValue).format("HH:mm")}`,
          value: {
            from: props.minValue && moment(props.minValue).format("HH:mm"),
            to: props.maxValue && moment(props.maxValue).format("HH:mm"),
          },
        },
      });
      return;
    }
    if (props.min != null && props.max != null) {
      filterValue = {
        text: props.useData > 0 ? `${moment(props.min).format("HH:mm")} - ${moment(props.max).format("HH:mm")}` : null,
        value: {
          from: props.useData > 0 ? moment(props.min).format("HH:mm") : null,
          to: props.useData > 0 ? moment(props.max).format("HH:mm") : null,
        },
      };
    } else if (props.useData) {
      filterValue = props.useData;
    }
    this.setState({ open: false, filterValue });
  }
  handleOpenClose = (open) => {
    this.setState({ open });
  }

  handleAccept = () => {
    const {
      desde,
      hasta,
    } = this.state;

    let filterValue;

    if (desde != null && hasta != null) {
      filterValue = {
        text: `${moment(this.state.desde).format("HH:mm")} - ${moment(this.state.hasta).format("HH:mm")}`,
        value: {
          from: moment(this.state.desde).format("HH:mm"),
          to: moment(this.state.hasta).format("HH:mm"),
        },
      };
    }

    this.setState({ open: false, filterValue });
    this.props.callBackHours(filterValue);
  }


  handleChangeDesde = (e) => {
    if (e.value !== null) {
      this.setState({
        desde: e.value,
      });


      if (this.state.desde && this.state.hasta) {
        if (this.state.desde > this.state.hasta) {
          this.setState({ filtrarValid: false });
        } else {
          this.setState({ filtrarValid: true });
        }
      }
    } else {
      this.setState({ desde: null });
      if (this.state.hasta) {
        this.setState({ hasta: null });
      }
    }
  }

  handleChangeHasta = (e) => {
    this.setState({ hasta: e.value });
    if (!e.value && this.state.desde) {
      this.setState({ desde: null });
    }
    if (this.state.hasta && this.state.desde) {
      if (this.state.hasta < this.state.desde) {
        this.setState({ filtrarValid: false });
      } else {
        this.setState({ filtrarValid: true });
      }
    }
  }

  handleCancel = () => {
    if (this.props.minValue != null) {
      this.setState({ open: false });
    } else {
      this.setState({
        open: false, hasta: null, desde: null, filtrarValid: true, filterValue: null,
      });
      this.handleAccept();
    }
  }

  render() {
    return (
      <React.Fragment>
        <SelectBox
          onInitialized={(e) => {
            e.component.option("openOnFieldClick", false);
          }}
          displayExpr="Name"
          id={this.props.column}
          disabled={this.props.disabled}
          className="select-table-filter"
          fieldComponent={(props) => (
            <div className="select-table-filter-field" onClickCapture={() => this.handleOpenClose(!this.state.open)}>
              <span>{this.state.filterValue && this.state.filterValue.text}</span>
              <TextBox readOnly visible={false} />
              <i className="dx-icon dx-icon-filter"></i>
            </div>
          )}
        >
          <Validator
            validationRules={this.props.validationCallBack ? [{
              type: "custom",
              validationCallback: this.props.validationCallBack,
              message: "Este campo es requerido",
            }] : []}
          />
        </SelectBox>
        <Popover
          onHiding={() => this.setState({ open: false })}
          closeOnOutsideClick
          visible={this.state.open}
          width={250}
          target={`#${this.props.column}`}
          position={{ offset: "0 16", my: "top" }}
          animation={{
            show: {
              type: "pop",
              duration: 0,
            },
          }}
        >
          <DateBox
            type="time"
            width={230}
            placeholder="Desde"
            min={this.props.min}
            max={this.state.hasta ? this.state.hasta : this.props.max}
            showClearButton
            onValueChanged={this.handleChangeDesde}
            value={this.state.desde}
            validationError={{ message: "Fecha indicada es mayor a la fecha final" }}
          />
          <DateBox
            type="time"
            width={230}
            placeholder="Hasta"
            showClearButton
            min={this.state.desde ? moment(this.state.desde).add(30, "minutes").format() : this.props.min}
            max={this.props.max}
            onValueChanged={this.handleChangeHasta}
            value={this.state.hasta}
            style={{ marginTop: 10 }}
            validationError={{ message: "Fecha indicada es menor a la fecha inicial" }}
          />
          <div style={{ marginTop: 10 }}>
            <Button text="Cerrar" onClick={this.handleCancel} />
            <Button
              text="Seleccionar"
              className="filter-accept-button"
              disabled={!this.state.filtrarValid}
              onClick={this.handleAccept}
            />
          </div>
        </Popover>
      </React.Fragment>
    );
  }
}

export default HoursRanges;
